export namespace ReorderableArray {
  export type DropTarget<TId extends string = string> = {
    prevId: TId | null;
    nextId: TId | null;
  };

  function moveItem<T>(items: readonly T[], fromIndex: number, toIndex: number): T[] {
    const nextItems = [...items];
    const [item] = nextItems.splice(fromIndex, 1);
    if (item === undefined) {
      return nextItems;
    }

    nextItems.splice(toIndex, 0, item);
    return nextItems;
  }

  export function getDropTargetFromOverId<TItem, TId extends string>(args: {
    items: readonly TItem[];
    getItemId: (item: TItem) => TId;
    activeId: TId;
    overId: TId | null;
  }): DropTarget<TId> | null {
    const { items, getItemId, activeId, overId } = args;

    if (!overId || activeId === overId) {
      return null;
    }

    const activeIndex = items.findIndex((item) => getItemId(item) === activeId);
    const overIndex = items.findIndex((item) => getItemId(item) === overId);
    if (activeIndex === -1 || overIndex === -1) {
      return null;
    }

    const reorderedItems = moveItem(items, activeIndex, overIndex);
    const nextIndex = reorderedItems.findIndex((item) => getItemId(item) === activeId);
    if (nextIndex === -1) {
      return null;
    }

    const prevItem = reorderedItems[nextIndex - 1];
    const nextItem = reorderedItems[nextIndex + 1];

    return {
      prevId: prevItem ? getItemId(prevItem) : null,
      nextId: nextItem ? getItemId(nextItem) : null,
    };
  }
}
